var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4829_90710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87383 14.4252C11.0738 13.9832 12.2408 15.1502 11.7988 16.3512L9.18183 23.4652C9.12393 23.6228 9.02726 23.7633 8.90075 23.8738C8.77425 23.9842 8.62197 24.061 8.45798 24.097C8.29398 24.1331 8.12354 24.1273 7.96238 24.0801C7.80122 24.033 7.65453 23.946 7.53584 23.8272L2.39784 18.6892C2.27929 18.5705 2.19252 18.4239 2.1455 18.2629C2.09849 18.1018 2.09274 17.9315 2.1288 17.7677C2.16485 17.6038 2.24155 17.4517 2.35183 17.3253C2.4621 17.1989 2.60241 17.1022 2.75984 17.0442L9.87384 14.4242L9.87383 14.4252Z",
    fill: "url(#paint0_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87383 14.4252C11.0738 13.9832 12.2408 15.1502 11.7988 16.3512L9.18183 23.4652C9.12393 23.6228 9.02726 23.7633 8.90075 23.8738C8.77425 23.9842 8.62197 24.061 8.45798 24.097C8.29398 24.1331 8.12354 24.1273 7.96238 24.0801C7.80122 24.033 7.65453 23.946 7.53584 23.8272L2.39784 18.6892C2.27929 18.5705 2.19252 18.4239 2.1455 18.2629C2.09849 18.1018 2.09274 17.9315 2.1288 17.7677C2.16485 17.6038 2.24155 17.4517 2.35183 17.3253C2.4621 17.1989 2.60241 17.1022 2.75984 17.0442L9.87384 14.4242L9.87383 14.4252Z",
    fill: "url(#paint1_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87383 14.4252C11.0738 13.9832 12.2408 15.1502 11.7988 16.3512L9.18183 23.4652C9.12393 23.6228 9.02726 23.7633 8.90075 23.8738C8.77425 23.9842 8.62197 24.061 8.45798 24.097C8.29398 24.1331 8.12354 24.1273 7.96238 24.0801C7.80122 24.033 7.65453 23.946 7.53584 23.8272L2.39784 18.6892C2.27929 18.5705 2.19252 18.4239 2.1455 18.2629C2.09849 18.1018 2.09274 17.9315 2.1288 17.7677C2.16485 17.6038 2.24155 17.4517 2.35183 17.3253C2.4621 17.1989 2.60241 17.1022 2.75984 17.0442L9.87384 14.4242L9.87383 14.4252Z",
    fill: "url(#paint2_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8728 20.4252C17.0738 19.9832 18.2408 21.1502 17.7988 22.3512L15.1798 29.4652C15.1219 29.6227 15.0252 29.763 14.8988 29.8732C14.7724 29.9835 14.6202 30.0602 14.4564 30.0963C14.2925 30.1323 14.1222 30.1266 13.9612 30.0796C13.8002 30.0325 13.6535 29.9458 13.5348 29.8272L8.39683 24.6892C8.27829 24.5705 8.19152 24.4239 8.1445 24.2629C8.09749 24.1018 8.09174 23.9315 8.1278 23.7677C8.16385 23.6038 8.24055 23.4517 8.35083 23.3253C8.4611 23.1989 8.60141 23.1022 8.75884 23.0442L15.8728 20.4242L15.8728 20.4252Z",
    fill: "url(#paint3_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8728 20.4252C17.0738 19.9832 18.2408 21.1502 17.7988 22.3512L15.1798 29.4652C15.1219 29.6227 15.0252 29.763 14.8988 29.8732C14.7724 29.9835 14.6202 30.0602 14.4564 30.0963C14.2925 30.1323 14.1222 30.1266 13.9612 30.0796C13.8002 30.0325 13.6535 29.9458 13.5348 29.8272L8.39683 24.6892C8.27829 24.5705 8.19152 24.4239 8.1445 24.2629C8.09749 24.1018 8.09174 23.9315 8.1278 23.7677C8.16385 23.6038 8.24055 23.4517 8.35083 23.3253C8.4611 23.1989 8.60141 23.1022 8.75884 23.0442L15.8728 20.4242L15.8728 20.4252Z",
    fill: "url(#paint4_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8728 20.4252C17.0738 19.9832 18.2408 21.1502 17.7988 22.3512L15.1798 29.4652C15.1219 29.6227 15.0252 29.763 14.8988 29.8732C14.7724 29.9835 14.6202 30.0602 14.4564 30.0963C14.2925 30.1323 14.1222 30.1266 13.9612 30.0796C13.8002 30.0325 13.6535 29.9458 13.5348 29.8272L8.39683 24.6892C8.27829 24.5705 8.19152 24.4239 8.1445 24.2629C8.09749 24.1018 8.09174 23.9315 8.1278 23.7677C8.16385 23.6038 8.24055 23.4517 8.35083 23.3253C8.4611 23.1989 8.60141 23.1022 8.75884 23.0442L15.8728 20.4242L15.8728 20.4252Z",
    fill: "url(#paint5_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 4.25723C21.7192 4.24637 21.7491 4.24381 21.7779 4.24986C21.8068 4.2559 21.8331 4.27029 21.8538 4.29123L27.7388 10.2212C27.7596 10.242 27.7738 10.2685 27.7797 10.2973C27.7855 10.3261 27.7828 10.356 27.7718 10.3832C26.3618 13.8432 24.4188 17.5232 21.8178 20.1252C19.2838 22.6592 14.9978 24.8182 11.1278 26.4062L5.63683 20.9142C7.22483 17.0442 9.38383 12.7592 11.9178 10.2252C14.5278 7.61523 18.2218 5.66823 21.6908 4.25823L21.6918 4.25723Z",
    fill: "url(#paint6_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 4.25723C21.7192 4.24637 21.7491 4.24381 21.7779 4.24986C21.8068 4.2559 21.8331 4.27029 21.8538 4.29123L27.7388 10.2212C27.7596 10.242 27.7738 10.2685 27.7797 10.2973C27.7855 10.3261 27.7828 10.356 27.7718 10.3832C26.3618 13.8432 24.4188 17.5232 21.8178 20.1252C19.2838 22.6592 14.9978 24.8182 11.1278 26.4062L5.63683 20.9142C7.22483 17.0442 9.38383 12.7592 11.9178 10.2252C14.5278 7.61523 18.2218 5.66823 21.6908 4.25823L21.6918 4.25723Z",
    fill: "url(#paint7_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 4.25723C21.7192 4.24637 21.7491 4.24381 21.7779 4.24986C21.8068 4.2559 21.8331 4.27029 21.8538 4.29123L27.7388 10.2212C27.7596 10.242 27.7738 10.2685 27.7797 10.2973C27.7855 10.3261 27.7828 10.356 27.7718 10.3832C26.3618 13.8432 24.4188 17.5232 21.8178 20.1252C19.2838 22.6592 14.9978 24.8182 11.1278 26.4062L5.63683 20.9142C7.22483 17.0442 9.38383 12.7592 11.9178 10.2252C14.5278 7.61523 18.2218 5.66823 21.6908 4.25823L21.6918 4.25723Z",
    fill: "url(#paint8_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 4.25723C21.7192 4.24637 21.7491 4.24381 21.7779 4.24986C21.8068 4.2559 21.8331 4.27029 21.8538 4.29123L27.7388 10.2212C27.7596 10.242 27.7738 10.2685 27.7797 10.2973C27.7855 10.3261 27.7828 10.356 27.7718 10.3832C26.3618 13.8432 24.4188 17.5232 21.8178 20.1252C19.2838 22.6592 14.9978 24.8182 11.1278 26.4062L5.63683 20.9142C7.22483 17.0442 9.38383 12.7592 11.9178 10.2252C14.5278 7.61523 18.2218 5.66823 21.6908 4.25823L21.6918 4.25723Z",
    fill: "url(#paint9_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 4.25723C21.7192 4.24637 21.7491 4.24381 21.7779 4.24986C21.8068 4.2559 21.8331 4.27029 21.8538 4.29123L27.7388 10.2212C27.7596 10.242 27.7738 10.2685 27.7797 10.2973C27.7855 10.3261 27.7828 10.356 27.7718 10.3832C26.3618 13.8432 24.4188 17.5232 21.8178 20.1252C19.2838 22.6592 14.9978 24.8182 11.1278 26.4062L5.63683 20.9142C7.22483 17.0442 9.38383 12.7592 11.9178 10.2252C14.5278 7.61523 18.2218 5.66823 21.6908 4.25823L21.6918 4.25723Z",
    fill: "url(#paint10_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7918 11.7692C23.7995 12.2153 23.7183 12.6584 23.5529 13.0727C23.3876 13.4871 23.1413 13.8643 22.8286 14.1825C22.5159 14.5006 22.1429 14.7534 21.7315 14.9259C21.3201 15.0983 20.8785 15.1872 20.4323 15.1872C19.9862 15.1872 19.5446 15.0983 19.1331 14.9259C18.7217 14.7534 18.3488 14.5006 18.036 14.1825C17.7233 13.8643 17.4771 13.4871 17.3117 13.0727C17.1463 12.6584 17.0651 12.2153 17.0728 11.7692C17.088 10.8883 17.4487 10.0485 18.077 9.43091C18.7054 8.81328 19.5512 8.46719 20.4323 8.46719C21.3134 8.46719 22.1593 8.81328 22.7876 9.4309C23.416 10.0485 23.7766 10.8883 23.7918 11.7692Z",
    fill: "url(#paint11_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7918 11.7692C23.7995 12.2153 23.7183 12.6584 23.5529 13.0727C23.3876 13.4871 23.1413 13.8643 22.8286 14.1825C22.5159 14.5006 22.1429 14.7534 21.7315 14.9259C21.3201 15.0983 20.8785 15.1872 20.4323 15.1872C19.9862 15.1872 19.5446 15.0983 19.1331 14.9259C18.7217 14.7534 18.3488 14.5006 18.036 14.1825C17.7233 13.8643 17.4771 13.4871 17.3117 13.0727C17.1463 12.6584 17.0651 12.2153 17.0728 11.7692C17.088 10.8883 17.4487 10.0485 18.077 9.43091C18.7054 8.81328 19.5512 8.46719 20.4323 8.46719C21.3134 8.46719 22.1593 8.81328 22.7876 9.4309C23.416 10.0485 23.7766 10.8883 23.7918 11.7692Z",
    fill: "url(#paint12_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 11.7692C22.7643 12.0787 22.7088 12.3863 22.5949 12.674C22.4809 12.9618 22.3106 13.2239 22.094 13.445C21.8774 13.6662 21.6189 13.8418 21.3336 13.9618C21.0482 14.0817 20.7418 14.1435 20.4323 14.1435C20.1228 14.1435 19.8164 14.0817 19.5311 13.9618C19.2457 13.8418 18.9872 13.6662 18.7706 13.445C18.5541 13.2239 18.3838 12.9618 18.2698 12.674C18.1558 12.3863 18.1004 12.0787 18.1068 11.7692C18.1195 11.1608 18.37 10.5816 18.8047 10.1558C19.2395 9.72994 19.8238 9.49145 20.4323 9.49145C21.0409 9.49145 21.6252 9.72994 22.0599 10.1558C22.4947 10.5816 22.7452 11.1608 22.7578 11.7692Z",
    fill: "url(#paint13_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 30.2402C1.00784 29.5332 1.29184 24.6292 3.79184 23.6292C3.79184 23.6292 6.29184 22.6292 7.90284 24.2292C9.51384 25.8292 8.79184 27.6292 8.79184 27.6292C8.08484 29.7502 5.07484 30.5932 4.72084 30.2392C4.52584 30.0442 4.87684 29.6892 4.72084 29.5332C4.56484 29.3762 4.32284 29.5552 3.66084 29.8862C3.18884 30.1222 1.99784 30.5232 1.71484 30.2402Z",
    fill: "url(#paint14_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 30.2402C1.00784 29.5332 1.29184 24.6292 3.79184 23.6292C3.79184 23.6292 6.29184 22.6292 7.90284 24.2292C9.51384 25.8292 8.79184 27.6292 8.79184 27.6292C8.08484 29.7502 5.07484 30.5932 4.72084 30.2392C4.52584 30.0442 4.87684 29.6892 4.72084 29.5332C4.56484 29.3762 4.32284 29.5552 3.66084 29.8862C3.18884 30.1222 1.99784 30.5232 1.71484 30.2402Z",
    fill: "url(#paint15_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35183 21.6892C5.49114 21.5498 5.65654 21.4393 5.83859 21.3638C6.02064 21.2884 6.21577 21.2495 6.41283 21.2495C6.6099 21.2495 6.80503 21.2884 6.98708 21.3638C7.16913 21.4393 7.33453 21.5498 7.47384 21.6892L11.0088 25.2252C11.2773 25.5089 11.4245 25.8862 11.4192 26.2767C11.4139 26.6673 11.2564 27.0404 10.9802 27.3166C10.7041 27.5929 10.3311 27.7506 9.94055 27.7561C9.54998 27.7616 9.17267 27.6146 8.88883 27.3462L5.35183 23.8112C5.21245 23.6719 5.10187 23.5065 5.02643 23.3245C4.95099 23.1424 4.91216 22.9473 4.91216 22.7502C4.91216 22.5532 4.95099 22.358 5.02643 22.176C5.10187 21.9939 5.21245 21.8285 5.35183 21.6892Z",
    fill: "url(#paint16_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35183 21.6892C5.49114 21.5498 5.65654 21.4393 5.83859 21.3638C6.02064 21.2884 6.21577 21.2495 6.41283 21.2495C6.6099 21.2495 6.80503 21.2884 6.98708 21.3638C7.16913 21.4393 7.33453 21.5498 7.47384 21.6892L11.0088 25.2252C11.2773 25.5089 11.4245 25.8862 11.4192 26.2767C11.4139 26.6673 11.2564 27.0404 10.9802 27.3166C10.7041 27.5929 10.3311 27.7506 9.94055 27.7561C9.54998 27.7616 9.17267 27.6146 8.88883 27.3462L5.35183 23.8112C5.21245 23.6719 5.10187 23.5065 5.02643 23.3245C4.95099 23.1424 4.91216 22.9473 4.91216 22.7502C4.91216 22.5532 4.95099 22.358 5.02643 22.176C5.10187 21.9939 5.21245 21.8285 5.35183 21.6892Z",
    fill: "url(#paint17_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35183 21.6892C5.49114 21.5498 5.65654 21.4393 5.83859 21.3638C6.02064 21.2884 6.21577 21.2495 6.41283 21.2495C6.6099 21.2495 6.80503 21.2884 6.98708 21.3638C7.16913 21.4393 7.33453 21.5498 7.47384 21.6892L11.0088 25.2252C11.2773 25.5089 11.4245 25.8862 11.4192 26.2767C11.4139 26.6673 11.2564 27.0404 10.9802 27.3166C10.7041 27.5929 10.3311 27.7506 9.94055 27.7561C9.54998 27.7616 9.17267 27.6146 8.88883 27.3462L5.35183 23.8112C5.21245 23.6719 5.10187 23.5065 5.02643 23.3245C4.95099 23.1424 4.91216 22.9473 4.91216 22.7502C4.91216 22.5532 4.95099 22.358 5.02643 22.176C5.10187 21.9939 5.21245 21.8285 5.35183 21.6892Z",
    fill: "url(#paint18_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4638 3.57823C27.5168 2.63123 25.8558 2.73823 24.6458 3.15423C23.7329 3.46708 22.8279 3.80286 21.9318 4.16123C21.9165 4.16736 21.903 4.17718 21.8924 4.18981C21.8818 4.20244 21.8745 4.21749 21.8712 4.23362C21.8678 4.24975 21.8685 4.26646 21.8731 4.28227C21.8778 4.29808 21.8863 4.31249 21.8978 4.32423L27.7078 10.1732C27.7195 10.1846 27.7338 10.1929 27.7494 10.1975C27.7651 10.2021 27.7816 10.2028 27.7976 10.1996C27.8135 10.1963 27.8285 10.1892 27.8411 10.1789C27.8537 10.1685 27.8635 10.1553 27.8698 10.1402C28.2327 9.23468 28.5725 8.32005 28.8888 7.39723C29.2988 6.20323 29.6288 4.74323 28.4638 3.57823Z",
    fill: "url(#paint19_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4638 3.57823C27.5168 2.63123 25.8558 2.73823 24.6458 3.15423C23.7329 3.46708 22.8279 3.80286 21.9318 4.16123C21.9165 4.16736 21.903 4.17718 21.8924 4.18981C21.8818 4.20244 21.8745 4.21749 21.8712 4.23362C21.8678 4.24975 21.8685 4.26646 21.8731 4.28227C21.8778 4.29808 21.8863 4.31249 21.8978 4.32423L27.7078 10.1732C27.7195 10.1846 27.7338 10.1929 27.7494 10.1975C27.7651 10.2021 27.7816 10.2028 27.7976 10.1996C27.8135 10.1963 27.8285 10.1892 27.8411 10.1789C27.8537 10.1685 27.8635 10.1553 27.8698 10.1402C28.2327 9.23468 28.5725 8.32005 28.8888 7.39723C29.2988 6.20323 29.6288 4.74323 28.4638 3.57823Z",
    fill: "url(#paint20_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4638 3.57823C27.5168 2.63123 25.8558 2.73823 24.6458 3.15423C23.7329 3.46708 22.8279 3.80286 21.9318 4.16123C21.9165 4.16736 21.903 4.17718 21.8924 4.18981C21.8818 4.20244 21.8745 4.21749 21.8712 4.23362C21.8678 4.24975 21.8685 4.26646 21.8731 4.28227C21.8778 4.29808 21.8863 4.31249 21.8978 4.32423L27.7078 10.1732C27.7195 10.1846 27.7338 10.1929 27.7494 10.1975C27.7651 10.2021 27.7816 10.2028 27.7976 10.1996C27.8135 10.1963 27.8285 10.1892 27.8411 10.1789C27.8537 10.1685 27.8635 10.1553 27.8698 10.1402C28.2327 9.23468 28.5725 8.32005 28.8888 7.39723C29.2988 6.20323 29.6288 4.74323 28.4638 3.57823Z",
    fill: "url(#paint21_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 17.4252C14.0738 16.9832 15.2408 18.1502 14.7988 19.3512L12.1808 26.4652C12.1229 26.6228 12.0263 26.7633 11.8998 26.8738C11.7732 26.9842 11.621 27.061 11.457 27.097C11.293 27.1331 11.1225 27.1273 10.9614 27.0801C10.8002 27.033 10.6535 26.946 10.5348 26.8272L5.39683 21.6892C5.27829 21.5705 5.19152 21.4239 5.1445 21.2629C5.09749 21.1018 5.09174 20.9315 5.1278 20.7677C5.16386 20.6038 5.24055 20.4517 5.35083 20.3253C5.4611 20.1989 5.60141 20.1022 5.75883 20.0442L12.8738 17.4242L12.8738 17.4252Z",
    fill: "url(#paint22_linear_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 17.4252C14.0738 16.9832 15.2408 18.1502 14.7988 19.3512L12.1808 26.4652C12.1229 26.6228 12.0263 26.7633 11.8998 26.8738C11.7732 26.9842 11.621 27.061 11.457 27.097C11.293 27.1331 11.1225 27.1273 10.9614 27.0801C10.8002 27.033 10.6535 26.946 10.5348 26.8272L5.39683 21.6892C5.27829 21.5705 5.19152 21.4239 5.1445 21.2629C5.09749 21.1018 5.09174 20.9315 5.1278 20.7677C5.16386 20.6038 5.24055 20.4517 5.35083 20.3253C5.4611 20.1989 5.60141 20.1022 5.75883 20.0442L12.8738 17.4242L12.8738 17.4252Z",
    fill: "url(#paint23_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 17.4252C14.0738 16.9832 15.2408 18.1502 14.7988 19.3512L12.1808 26.4652C12.1229 26.6228 12.0263 26.7633 11.8998 26.8738C11.7732 26.9842 11.621 27.061 11.457 27.097C11.293 27.1331 11.1225 27.1273 10.9614 27.0801C10.8002 27.033 10.6535 26.946 10.5348 26.8272L5.39683 21.6892C5.27829 21.5705 5.19152 21.4239 5.1445 21.2629C5.09749 21.1018 5.09174 20.9315 5.1278 20.7677C5.16386 20.6038 5.24055 20.4517 5.35083 20.3253C5.4611 20.1989 5.60141 20.1022 5.75883 20.0442L12.8738 17.4242L12.8738 17.4252Z",
    fill: "url(#paint24_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 17.4252C14.0738 16.9832 15.2408 18.1502 14.7988 19.3512L12.1808 26.4652C12.1229 26.6228 12.0263 26.7633 11.8998 26.8738C11.7732 26.9842 11.621 27.061 11.457 27.097C11.293 27.1331 11.1225 27.1273 10.9614 27.0801C10.8002 27.033 10.6535 26.946 10.5348 26.8272L5.39683 21.6892C5.27829 21.5705 5.19152 21.4239 5.1445 21.2629C5.09749 21.1018 5.09174 20.9315 5.1278 20.7677C5.16386 20.6038 5.24055 20.4517 5.35083 20.3253C5.4611 20.1989 5.60141 20.1022 5.75883 20.0442L12.8738 17.4242L12.8738 17.4252Z",
    fill: "url(#paint25_radial_4829_90710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49684 22.7542L14.1218 18.3472L10.4968 24.7852L8.49684 22.7542Z",
    fill: "url(#paint26_linear_4829_90710)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4829_90710",
    x1: 14.7507,
    y1: 14.3723,
    x2: -2.10137,
    y2: 22.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63E7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.14905 29.6439) rotate(-54.6832) scale(29.4369 2.58653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#FF8DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8DB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4829_90710",
    x1: 9.11297,
    y1: 26.2272,
    x2: 8.2337,
    y2: 23.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#DD467C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD467C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4829_90710",
    x1: 22.9689,
    y1: 1.96017,
    x2: 27.8137,
    y2: 21.2759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3190"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6133 11.6763) rotate(37.5473) scale(13.9414 25.2402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E76CBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#E76CBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7112 19.9147) rotate(-81.2543) scale(13.6043 6.27295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4829_90710",
    x1: 7.09247,
    y1: 18.3953,
    x2: 19.1151,
    y2: 22.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD2EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0442 13.0619) rotate(154.854) scale(23.9723 29.7897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E7E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.05902 30.7446) rotate(-80.8022) scale(11.2489 5.48547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#B5A3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A3A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.94775 33.4748) rotate(-102.969) scale(7.87854 2.21919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#B28F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28F96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6369 1.08157) rotate(111.556) scale(17.9935 4.09145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAECF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4829_90710",
    x1: 0.676878,
    y1: 29.1983,
    x2: 31.4289,
    y2: 7.86473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A796A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5959F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1 16.908) rotate(45) scale(8.87307 18.8802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#93859B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93859B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3447 23.1704) rotate(-135) scale(18.488 36.1782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#66ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B57F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0175 5.50033) rotate(108.103) scale(22.9568 14.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9542"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8636 13.5496) rotate(165.103) scale(27.2311 25.1259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FFC484",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4829_90710",
    x1: -0.975528,
    y1: 26.0915,
    x2: 24.5552,
    y2: 35.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#452860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51509F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.29536 20.8917) rotate(20.3494) scale(4.78347 7.7734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E839A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E839A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.70395 21.2059) rotate(-17.4888) scale(27.2359 11.7595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6175B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6175B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4829_90710",
    x1: 20.6516,
    y1: 1.53178,
    x2: 26.0578,
    y2: 16.6361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED224B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5827 5.62513) rotate(109.693) scale(32.9276 6.10923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#FF5971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5971",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4829_90710",
    x1: 15.2336,
    y1: 20.3342,
    x2: 14.6646,
    y2: 18.8225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2575E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93251",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4829_90710",
    x1: 21.6397,
    y1: -0.831084,
    x2: 28.8596,
    y2: 19.1906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2982"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.318015 26.5335) rotate(-55.1552) scale(27.3114 3.7285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF95AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF95AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.832142 29.9551) rotate(-20.0565) scale(13.9409 3.14953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#E14678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4829_90710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.534 11.5945) rotate(33.7799) scale(13.6305 29.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#E67BC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67BC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4829_90710",
    x1: 13.2793,
    y1: 18.8151,
    x2: 9.15425,
    y2: 23.1281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5794"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4829_90710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.6bf51a5e56097ccd0ff39b2eb75327c9.svg";
export { ForwardRef as ReactComponent };